module.exports = __webpack_public_path__ + "img/portfolio-06-480x253.1577f366.jpg";